import React from 'react'
import { Grid } from '@fs/zion-ui'
import { arrayOf, string, shape, number, oneOfType } from 'prop-types'
import CardSlider from '../CardSlider'
import { FamilyGroupType } from '../../sharedPropTypes/familyGroupProps'
import { ActivityGroupType } from '../../sharedPropTypes/activityProps'
import ActivityGroupGridLoadingSkeleton from './ActivityGroupGridLoadingSkeleton'

const ActivityGroupsGrid = React.memo(
  ({ categories, topicId, familyGroup, answerCounts }) => {
    if (!categories) {
      return (
        <Grid>
          <ActivityGroupGridLoadingSkeleton />
        </Grid>
      )
    }

    return (
      <>
        {categories.map((category) => (
          <CardSlider
            title={category?.title}
            key={category?.categoryId}
            cards={category?.activityGroups}
            answerCounts={answerCounts}
            familyGroup={familyGroup}
            categoryId={category?.categoryId}
            topicId={topicId}
            editable={category?.dismissable}
          />
        ))}
      </>
    )
  },
  (prevProps, nextProps) => {
    return (
      // also trigger rerender if counts change
      prevProps.categories === nextProps.categories &&
      prevProps.topicId === nextProps.topicId &&
      prevProps.familyGroup === nextProps.familyGroup &&
      prevProps.answerCounts.map((item) => item.count).join(',') ===
        nextProps.answerCounts.map((item) => item.count).join(',')
    )
  }
)

ActivityGroupsGrid.propTypes = {
  answerCounts: arrayOf(
    shape({
      visibleId: string,
      count: number,
      personId: string,
    })
  ),
  categories: arrayOf(
    shape({
      topicId: oneOfType([string, number]),
      title: string,
      activityGroups: arrayOf(ActivityGroupType),
    })
  ),
  topicId: oneOfType([string, number]),
  familyGroup: FamilyGroupType,
}

export default ActivityGroupsGrid
